module.exports = __webpack_public_path__ + "img/11_97.3d48d4c5.png";